export default [
    {
        path: '/terms',
        name: 'terms',
        component: () => import('../../pages/terms/IndexPage.vue'),
        meta: {
            title: 'Terms Management',
            requiresAuth: true,
        },
    },
]
